import script from "./howToGetScore.vue?vue&type=script&setup=true&lang=ts"
export * from "./howToGetScore.vue?vue&type=script&setup=true&lang=ts"

import "./howToGetScore.vue?vue&type=style&index=0&id=703eb3aa&lang=scss&scoped=true"
import "./howToGetScore.vue?vue&type=style&index=1&id=703eb3aa&lang=scss"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-703eb3aa"]])

export default __exports__